import lang from "translations";

export const DuplicateTicketsReportColumns = [
  {
    key: "row",
    text: lang.snAbbr,
  },
  {
    key: "ticketId",
    text: lang.ticketId,
  },
  {
    key: "duplication",
    text: lang.duplication,
  }
];
